module.exports = __webpack_public_path__ + "68315735a6b8d64c31cb1849a920fe59.png";